/**
 * Gemeinsame Konstanten für TravelStressTest.
 */
import { SHIP_TYPE_DEFS, SHIP_TYPE_COUNT } from '../config/ShipTypes';

let _maxShipsPerFleet = 0;
for (let i = 0; i < SHIP_TYPE_COUNT; i++) _maxShipsPerFleet += SHIP_TYPE_DEFS[i].displayMax;

export const MAX_SHIPS_PER_FLEET = _maxShipsPerFleet;
